
  
  import blogsBySlugCode from '@/apollo/queries/blog/blogsBySlugCode'
  import blogCategories from '@/apollo/queries/blog/blogCategories'
  import pageMeta from '~/mixins/pageMeta.js';
  
  export default {
    mixins: [pageMeta],
    
    layout: 'white',
    data() {
      return {
        blogAuthors: Array,
        blogs: Array,
        loading: 0,
        isBlogSideWidgetActive: false,
        blogCategory: Object,
      };
    },

    computed: {
      pageData() {
        return this.blogCategory[0]
      },
      BlogFiltersTagCodes () {
          return this.$store.getters['blog/filtersTagCodes']
      },
      BlogFiltersAuthorCodes() {
          return this.$store.getters['blog/filtersAuthorCodes']
      },
    },

    apollo: {
      $loadingKey: "loading",
      blogs: {
        prefetch: true,
        query: blogsBySlugCode,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , slugCode: this.$route.params.slug};
        },
        update(data) {
          return this.$normalizeStrapi(data.blogs.data);
        },
        result({ data }) {
          // console.info("***apollo blogs data ***");
          // console.debug(JSON.stringify(data));
        },
      },
      blogCategory: {
        prefetch: true,
        query: blogCategories,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , slugCode: this.$route.params.slug};
        },
        update(data) {
          return this.$normalizeStrapi(data.blogCategories.data);
        },
        result({ data }) {
          // console.info("***apollo blogs data ***");
          // console.debug(JSON.stringify(data));
        },
      },
    },

    mounted() {
      this.$store.commit('blog/clearTagCodes')
      this.$nextTick(() => {
        if(!this.$route.params.slug){
          this.$router?.push(
            {
              name: "blog___" + this.$i18n.locale
              // name: "blog___" + this.$i18n.locale
            }
          )
        }
      })
    },
    
    methods: {
      updateTagCodes(event){
        this.filters = event.filters;
        console.debug(event);
      },
      showBlogSideWidget(boolean) {
        this.isBlogSideWidgetActive = boolean
      },
      showFullBlogFilter(boolean) {
        this.$store.commit('blog/setDesktopMenuState', boolean)
      }
    },

  }
